export const SENDER_STORAGE_KEY = 'business_invoice_sender';
export const SENDER_EMPTY = { name: '', street: '', city: '', email: '', iban: '', bic: '', bank: '', taxNumber: '' };
export const loadSender = () => {
    try { return { ...SENDER_EMPTY, ...JSON.parse(localStorage.getItem(SENDER_STORAGE_KEY)) }; }
    catch { return SENDER_EMPTY; }
};
export const saveSender = (data) => localStorage.setItem(SENDER_STORAGE_KEY, JSON.stringify(data));

// Nutzereingaben (Kundenname, Adresse, Positionsbeschreibungen, Absenderdaten ...)
// landen unten als roher String in per document.write() gerendertem HTML — ohne
// Escaping könnte z.B. "<div style=position:absolute...>" im Namensfeld sichtbaren
// Inhalt der Rechnung überlagern/verfälschen (Skript-Ausführung selbst blockt die
// CSP bereits, reine HTML-Injection aber nicht).
const escHtml = (v) => String(v ?? '').replace(/[&<>"']/g, (c) => ({
    '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;',
}[c]));

export function buildInvoiceHTML({ nummer, datum, faellig, kundenname, adresse, positionen, mwst, dateFrom, dateTo, sender }) {
    const s = {
        name: escHtml(sender?.name), street: escHtml(sender?.street), city: escHtml(sender?.city),
        email: escHtml(sender?.email), iban: escHtml(sender?.iban), bic: escHtml(sender?.bic),
        bank: escHtml(sender?.bank), taxNumber: escHtml(sender?.taxNumber),
    };
    nummer = escHtml(nummer);
    datum = escHtml(datum);
    faellig = escHtml(faellig);
    kundenname = escHtml(kundenname);
    adresse = escHtml(adresse);
    dateFrom = escHtml(dateFrom);
    dateTo = escHtml(dateTo);
    const netto = positionen.reduce((sum, p) => sum + (parseFloat(p.preis) || 0) * (parseFloat(p.menge) || 0), 0);
    const mwstBetrag = netto * (mwst / 100);
    const gesamt = netto + mwstBetrag;
    const rows = positionen.map((p, i) => `
        <tr>
            <td style="padding:10px 12px;border-bottom:1px solid #e5e7eb;">${i + 1}</td>
            <td style="padding:10px 12px;border-bottom:1px solid #e5e7eb;">${escHtml(p.beschreibung) || '—'}</td>
            <td style="padding:10px 12px;border-bottom:1px solid #e5e7eb;text-align:center;">${escHtml(p.menge)}</td>
            <td style="padding:10px 12px;border-bottom:1px solid #e5e7eb;text-align:right;">${(parseFloat(p.preis) || 0).toFixed(2)} €</td>
            <td style="padding:10px 12px;border-bottom:1px solid #e5e7eb;text-align:right;font-weight:600;">${((parseFloat(p.preis) || 0) * (parseFloat(p.menge) || 0)).toFixed(2)} €</td>
        </tr>`).join('');
    return `<!DOCTYPE html><html lang="de"><head><meta charset="UTF-8">
    <title>Rechnung ${nummer}</title>
    <style>
        *{margin:0;padding:0;box-sizing:border-box;}
        @page{size:A4;margin:0;}
        body{font-family:Arial,Helvetica,sans-serif;font-size:14px;color:#111;background:#fff;padding:18mm 20mm 18mm 20mm;}
        .header{display:flex;justify-content:space-between;align-items:flex-start;margin-bottom:40px;}
        .logo{font-family:Georgia,'Times New Roman',serif;font-size:24px;font-weight:700;color:#1a1a1a;letter-spacing:-0.3px;}
        .sender-small{font-size:11px;color:#aaa;}
        .sender-block{margin-bottom:20px;}
        .meta{text-align:right;font-size:13px;color:#555;line-height:1.9;}
        .meta strong{color:#111;}
        .to{margin-bottom:32px;}
        .to .label{font-size:10px;text-transform:uppercase;letter-spacing:.1em;color:#aaa;margin-bottom:5px;}
        .to .name{font-size:16px;font-weight:700;}
        .to .addr{font-size:13px;color:#555;margin-top:3px;white-space:pre-line;}
        .period{font-size:12px;color:#888;margin-bottom:32px;}
        table{width:100%;border-collapse:collapse;margin-bottom:20px;}
        thead tr{background:#f9fafb;}
        thead th{padding:10px 12px;text-align:left;font-size:11px;text-transform:uppercase;letter-spacing:.06em;color:#888;border-bottom:2px solid #e5e7eb;}
        thead th:last-child,thead th:nth-last-child(2){text-align:right;}
        thead th:nth-child(3){text-align:center;}
        .totals{margin-left:auto;width:280px;}
        .totals tr td{padding:7px 12px;font-size:14px;}
        .totals tr td:last-child{text-align:right;font-weight:600;}
        .total-row td{font-size:17px;font-weight:800;border-top:2px solid #111;padding-top:12px;color:#1a1a1a;}
        .ust{font-size:12px;color:#888;margin-top:10px;}
        .bank{margin-top:48px;padding-top:18px;border-top:1px solid #e5e7eb;display:grid;grid-template-columns:1fr 1fr;gap:6px 32px;font-size:12px;color:#555;}
        .bank .lbl{font-size:10px;text-transform:uppercase;letter-spacing:.08em;color:#aaa;margin-bottom:1px;}
        .bank .val{font-weight:600;color:#111;}
        .due-note{margin-top:20px;padding:12px 16px;background:#f4f4f5;border-left:3px solid #1a1a1a;border-radius:6px;font-size:12.5px;color:#3f3f46;line-height:1.6;}
        .due-note strong{color:#18181b;}
        .toolbar{display:flex;gap:10px;margin-bottom:24px;}
        .toolbar button{font-family:Arial,Helvetica,sans-serif;font-size:14px;font-weight:700;padding:10px 20px;border-radius:8px;cursor:pointer;border:none;}
        .toolbar .dl{background:#1a1a1a;color:#fff;}
        .toolbar .pr{background:#f3f4f6;color:#111;border:1px solid #e5e7eb;}
        @media print{.toolbar{display:none;}}
    </style></head><body>
    <div class="toolbar">
        <button class="dl" id="dl-btn">⬇ PDF herunterladen</button>
        <button class="pr" id="pr-btn">Drucken</button>
    </div>
    <div id="invoice-content">
    <div class="header">
        <div>
            <div class="logo">&lt;MiS/&gt;</div>
            <div class="sender-block">
                <div class="sender-small">${s.street} · ${s.city} · ${s.email}</div>
                ${s.taxNumber ? `<div class="sender-small">Steuernummer: ${s.taxNumber}</div>` : ''}
            </div>
        </div>
        <div class="meta">
            <div><strong>Rechnungsnummer:</strong> ${nummer}</div>
            <div><strong>Rechnungsdatum:</strong> ${datum}</div>
            ${faellig ? `<div><strong>Zahlung fällig bis:</strong> ${faellig}</div>` : ''}
        </div>
    </div>
    <div class="to">
        <div class="label">Rechnung an</div>
        <div class="name">${kundenname || '—'}</div>
        ${adresse ? `<div class="addr">${adresse}</div>` : ''}
    </div>
    ${(dateFrom || dateTo) ? `<div class="period">Leistungszeitraum: ${dateFrom || '?'} – ${dateTo || '?'}</div>` : ''}
    <table>
        <thead><tr>
            <th style="width:40px;">#</th>
            <th>Beschreibung</th>
            <th style="width:70px;text-align:center;">Menge</th>
            <th style="width:110px;text-align:right;">Einzelpreis</th>
            <th style="width:110px;text-align:right;">Gesamt</th>
        </tr></thead>
        <tbody>${rows}</tbody>
    </table>
    <table class="totals">
        <tr><td>Netto</td><td>${netto.toFixed(2)} €</td></tr>
        ${mwst > 0 ? `<tr><td>MwSt. ${mwst}%</td><td>${mwstBetrag.toFixed(2)} €</td></tr>` : ''}
        <tr class="total-row"><td>Gesamtbetrag</td><td>${gesamt.toFixed(2)} €</td></tr>
    </table>
    ${mwst === 0 ? '<p class="ust">Gemäß § 19 UStG wird keine Umsatzsteuer berechnet.</p>' : ''}
    <div class="bank">
        <div><div class="lbl">Kontoinhaber</div><div class="val">${s.name}</div></div>
        <div><div class="lbl">Bank</div><div class="val">${s.bank}</div></div>
        <div><div class="lbl">IBAN</div><div class="val">${s.iban}</div></div>
        <div><div class="lbl">BIC</div><div class="val">${s.bic}</div></div>
    </div>
    ${faellig ? `<p class="due-note">Bitte begleiche den Rechnungsbetrag bis spätestens zum <strong>${faellig}</strong>. Vielen Dank für deine Zahlung!</p>` : ''}
    </div>
    <script src="${window.location.origin}/tools/html2pdf.bundle.min.js"></script>
    </body></html>`;
}

// Verdrahtet die Buttons im per window.open()/document.write() erzeugten Rechnungsfenster.
// Inline onclick-Attribute/<script>-Blöcke werden dort von der CSP (script-src 'self') blockiert,
// deshalb hängen wir die Listener vom Opener aus per addEventListener an.
export function wireInvoiceWindow(win, nummer) {
    if (!win || !win.document) return;
    const dlBtn = win.document.getElementById('dl-btn');
    const prBtn = win.document.getElementById('pr-btn');
    if (prBtn) prBtn.addEventListener('click', () => win.print());
    if (dlBtn) {
        dlBtn.addEventListener('click', () => {
            dlBtn.disabled = true;
            dlBtn.textContent = 'Erstelle PDF…';
            win.html2pdf().from(win.document.getElementById('invoice-content')).set({
                filename: `Rechnung-${nummer}.pdf`,
                // Array muss in der Realm des Popup-Fensters entstehen (win.Array, nicht das
                // globale Array des Openers) — sonst erkennt html2pdf.js' Typprüfung das Array
                // nicht und bricht mit "Invalid margin array." ab.
                margin: win.Array.of(18, 20, 18, 20),
                jsPDF: { unit: 'mm', format: 'a4', orientation: 'portrait' },
                html2canvas: { scale: 2 }
            }).save().then(() => {
                dlBtn.disabled = false;
                dlBtn.textContent = '⬇ PDF herunterladen';
            }).catch((err) => {
                dlBtn.disabled = false;
                dlBtn.textContent = '⬇ PDF herunterladen';
                win.alert('PDF konnte nicht erstellt werden: ' + (err && err.message ? err.message : err));
            });
        });
    }
}
